import $ from 'jquery';
import BannerSlider from '../entries/shop/components/banner-slider';
import GaPromotionTracking, { GaPromotionEventType } from '../core/components/ga-promotion-tracking';
export default class InlineVideo {
    static $videos = $('.js__inline-video');
    static $toggles = $('.js__inline-video-toggle');
    static init() {
        this.$toggles.each((_, toggle) => {
            const $toggle = $(toggle);
            const $video = $toggle.closest('.js__inline-video-wrapper').find('.js__inline-video');
            $toggle.on('click', event => {
                const $element = $(event.currentTarget);
                event.preventDefault();
                this.toggleVideo($video);
                this.promotionPlayEvent($element);
                $toggle.closest('.js__inline-video-wrapper').find('.js__inline-video-toggle-wrapper').remove();
            });
            $video.on('play pause', () => {
                this.updateState($video);
            });
            $video.on('play', () => {
                $video.removeAttr('tabindex');
                $video.removeAttr('aria-hidden');
            });
        });
    }
    static toggleVideo($video) {
        const video = $video.get(0);
        if (!video) {
            return;
        }
        if (video.paused || video.ended) {
            this.stopAllInlineVideos();
            video.play();
        }
        else {
            video.pause();
        }
    }
    static promotionPlayEvent($element) {
        const promotionId = $element.data('promotion-id');
        if (promotionId) {
            GaPromotionTracking.trackEvent($element, GaPromotionEventType.Click);
        }
    }
    static updateState($video) {
        const video = $video.get(0);
        if (!video) {
            return;
        }
        $video.toggleClass('playing', !video.paused && !video.ended);
        $video.toggleClass('paused', video.paused && !video.ended);
        if (!video.paused && !video.ended) {
            BannerSlider.stopAutoplay($video);
        }
        else if (video.paused || video.ended) {
            BannerSlider.startAutoplay($video);
        }
    }
    static stopAllInlineVideos() {
        this.$videos.each((_, video) => video.pause());
    }
}
